<template>
    <base-dialog :value="dialog" :width="460" :title="$t('common.unsubscribe_question')"
        @input="val => { if (!val) hide() }" @close="hide">
        <div class="baja-options">
            <div v-for="(option, i) in options" :key="i" v-ripple
                :class="['baja-option', { selected: option.value === currentOption }]" @click="onClickOption(option)">
                {{ option.text }}
            </div>
        </div>

        <template v-slot:footer>
            <v-btn block depressed x-large color="error" class="footer-btn" :disabled="disabled" @click="unsubscribe"
                :loading="loadingSubscribeCancel">
                {{ $t('common.unsubscribe') }}
            </v-btn>
        </template>
    </base-dialog>
</template>

<script>
import firebase from '@/utils/Firebase'
import BaseDialog from "@/components/common/BaseDialog";

import { db, Timestamp } from '../../utils/Firebase';

export default {
    components: { BaseDialog },
    props: {
        subscription: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            dialog: false,
            loadingSubscribeCancel: false,
            currentOption: null
        }
    },
    computed: {
        isStudent(vm = this) {
            return vm.account?.accountType === 'student'
        },
        httpsCallableMethod(vm = this) {
            return vm.isStudent ?
                'httpPayments-cancelSubscription' :
                'httpPayments-cancelSubscriptionCoach'
        },
        disabled(vm = this) {
            return !vm.currentOption
        },
        options(vm = this) {
            let options = [
                { text: vm.$t('common.unsubscribe_option1'), value: 'option1' },
                { text: vm.$t('common.unsubscribe_option2'), value: 'option2' },
                { text: vm.$t('common.unsubscribe_option3'), value: 'option3' },
                { text: vm.$t('common.unsubscribe_option4'), value: 'option4' },
            ]
            if (vm.isStudent) options = options.filter(option => option.value !== 'option2')
            return options
        }
    },
    methods: {
        show() {
            const vm = this
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        reset() {
            const vm = this;
            vm.currentOption = null
        },
        onClickOption(option) {
            const vm = this;
            if (vm.currentOption === option.value) return vm.currentOption = null
            vm.currentOption = option.value
        },
        async unsubscribe() {
            const vm = this
            if (!vm.subscription) return
            const reason = vm.currentOption

            await vm.withLoading(async () => {
                const payload = { subscriptionUID: vm.subscription.id }
                let cancelSubscription = firebase.functions().httpsCallable(vm.httpsCallableMethod)
                try {
                    await cancelSubscription(payload)
                } catch (err) {
                    vm.toast(`${vm.$t('payment.subscription_cancel_failed')}: ${err.message}`, 'error')
                    vm.$emit('error')
                    return
                }

                await db.collection('unsubscribes').add({
                    accountType: vm.account.accountType,
                    userId: vm.currentUser.uid,
                    reason,
                    date: vm.$moment().format('YYYY-MM-DD'),
                    createdAt: Timestamp.now()
                })

                vm.hide()

                vm.toast(`${vm.$t('payment.subscription_cancel_successful')}`)
                vm.$emit('success')
            }, 'loadingSubscribeCancel')
        },
    },

}
</script>

<style scoped>
.baja-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.baja-option {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 52px;
    padding: 10px 16px;
    border-radius: 10px;
    border: 1px solid var(--v-outline2-base);
    background: var(--v-surface-base);
    font-size: 14px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
    text-align: center;
    user-select: none;
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
}

.baja-option:hover {
    background: var(--v-surface2-base);
}

.baja-option.selected {
    border-color: var(--v-primary-base);
    background: rgba(204, 255, 51, 0.06);
}

.theme--light .baja-option.selected {
    border-color: var(--v-accent-base);
    background: rgba(51, 153, 153, 0.06);
}

.footer-btn {
    border-radius: 0 !important;
    height: 52px !important;
    font-weight: 700;
    letter-spacing: 0.04em;
}
</style>